import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { LayoutDashboard, Calendar, Users, Settings as SettingsIcon, LogOut, GitMerge, BarChart3, ListChecks, UserCog } from "lucide-react";

const items = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/events", icon: Calendar, label: "Events" },
  { to: "/admin/todo", icon: ListChecks, label: "To do" },
  { to: "/admin/tracking", icon: BarChart3, label: "Tracking" },
  { to: "/admin/vendors", icon: Users, label: "Vendors" },
  { to: "/admin/vendors/review", icon: ListChecks, label: "Review vendors" },
  { to: "/admin/settings", icon: SettingsIcon, label: "Settings" },
  { to: "/admin/team", icon: Users, label: "Team" },
  { to: "/admin/account", icon: UserCog, label: "My account" },
  { to: "/admin/tools/partner-sync", icon: GitMerge, label: "Partner Sync" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#f5f3ed] flex" data-admin="" data-testid="admin-layout">
      <aside className="w-64 border-r border-[#c19872] bg-white flex flex-col" data-testid="admin-sidebar">
        <div className="px-6 py-6 border-b border-[#dcd3c6]">
          <p className="btw-overline mb-1">Behind the Love</p>
          <p className="text-lg font-bold text-black">Editorial Desk</p>
        </div>
        <nav className="flex-1 py-4">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`nav-${it.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-2.5 text-sm transition-colors ${
                  isActive
                    ? "bg-[#c19872]/15 text-black font-bold border-l-2 border-[#c19872]"
                    : "text-black hover:bg-[#f5f3ed] border-l-2 border-transparent"
                }`
              }
            >
              <it.icon size={16} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-6 py-4 border-t border-[#dcd3c6] text-xs text-[#5c5852]">
          <div className="mb-2 truncate" data-testid="admin-user-email">{user?.email}</div>
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="flex items-center gap-2 hover:text-[#b35c5c]"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 btw-scroll overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
